<template>
  <transition-group :name="transition" tag="div">
    <field
      v-for="field in fields"
      :key="'field-' + field.slug"
      :field="field"
      :resource="resource"
      :tab="tab"
    />
  </transition-group>
</template>

<script>
import Field from './Field';

export default {
  components: {
    Field
  },
  props: {
    fields: {
      type: Array,
      required: true
    },
    transition: {
      type: String,
      default: 'push'
    },
    tab: {
      type: Object,
      required: true
    },
    resourceName: {
      type: String,
      required: true
    },
    resource: {
      type: Object,
      default: null
    }
  }
};
</script>
